import { HashRouter as Router, Route, Link, Routes, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

import Home from "./Home";
import Commercials from "./Commercials";
import About from "./About";
import Prints from "./Prints";
import Books from './Books';
import Charlie19 from './Charlie19';
import CaneDelleLacrime from './Cane';
import BataclanAttack from './BataclanAttack';
import SOMETIME from './SomeTime';

import Email from './images/icons/email_icon.png';
import Instagram from './images/icons/instagram_icon.png';
import CommercialsRoute from './Commercials-Collection/CommercialsRoute';
// const Home 

function App() {
    const [selectedId, setSelectedId] = useState(null);
    const [menuId, setMenuId] = useState(null);
    const handleClick = (id) => {
        setSelectedId(id);
        setMenuId("closed");
    };
    
    const toggleMenu = () => {
        setMenuId(prevId => (prevId === "open" ? null : "open"));
    };
    // const handleMenu = (id) => {
    //     setMenuId(id);
    // }
   
    return (

        <Router>
            
            <NavBar menuId={menuId} toggleMenu={toggleMenu} selectedId={selectedId} handleClick={handleClick}/>
            <div className={`overlay ${menuId === "open" ? "show" : ""}`}></div>
            <div id="content" >

                <Routes >
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/commercials" element={<Commercials/>}/>
                    <Route path="/books" element={<Books/>}/>
                    <Route path="/il-cane-delle-lacrime" element={<CaneDelleLacrime/>}/>
                    <Route path="/some-time" element={<SOMETIME/>}/>
                    <Route path="/19-charlie" element={<Charlie19/>}/>
                    <Route path="/bataclan-attack" element={<BataclanAttack/>}/>
                    <Route path="/prints" element={<Prints/>}/>
                    <Route path="/commercials/:id" element={<CommercialsRoute/>}/>
                </Routes>
            </div>
        </Router>

    );
}

const NavBar = ({ menuId, toggleMenu, selectedId, handleClick}) => {
    const location = useLocation();
    const currentPath = location.pathname; // Get the current path
    const isCommercialPage = currentPath.startsWith('/commercials'); // Check if on a commercial page
    const id = currentPath.split('/').pop(); // Get the last part of the path, which would be the ID
    // const title ={
    //     'm-le-monde-behind-the-bank': 'M Le Monde: Behind The Bank',
    //     'boden': 'Boden',
    //     'scimparello-magazine' : 'Scimparello Magazine',
    //     'm-le-monde-massimo-bottura' : 'M Le Monde: Massimo Bottura',
    //     'calliope': 'Calliope',
    //     'miro-wren': 'Miro & Wren',
    //     'the-north-face-mini-me': 'The North Face Mini Me'
    // }

    useEffect(() => {
        const emailButton = document.getElementById('emailButton');
        const instagramButton = document.getElementById('instagramButton');

        const handleEmailClick = () => {
            const recipient = 'iovinoalessandro88@gmail.com';
            const mailtoLink = `mailto:${recipient}?`;
            window.location.href = mailtoLink;
        };

        const handleInstagramClick = () => {
            window.location.href = 'https://www.instagram.com/alessandro.iovino_';
        };

        if (emailButton) {
            emailButton.addEventListener('click', handleEmailClick);
        }

        if (instagramButton) {
            instagramButton.addEventListener('click', handleInstagramClick);
        }

        // Cleanup function to remove the event listeners
        return () => {
            if (emailButton) {
                emailButton.removeEventListener('click', handleEmailClick);
            }
            if (instagramButton) {
                instagramButton.removeEventListener('click', handleInstagramClick);
            }
        };
    }, []);

    return(

        <div id="nav">
            <nav>
                <div className="nav-bar">
                    <div className="top">
                        <div className="title">
                            <Link to="/" onClick={() => handleClick("ale")}><h2>ALESSANDRO IOVINO</h2></Link>
                        </div>
                        <div className="hamb">
                            {/* <span></span>
                            <span></span>
                            <span></span> */}
                            <a onClick={toggleMenu}>Menu</a> 
                        </div>
                    </div>

                    <div className={ menuId === "open" ? "titles open" : "titles"}>
                        <div className="personal">
                            <Link to="/books" className={selectedId === "books" ? "selected" : ""} onClick={() => handleClick("books")}>Books</Link>
                        </div>
                        <div className='professional'>
                            <Link to="/il-cane-delle-lacrime" className={selectedId === "caneDelleLacrime" ? "selected" : ""} onClick={() => handleClick("caneDelleLacrime")}>Il Cane Delle Lacrime</Link>
                            <Link to="/some-time" className={selectedId === "someTime" ? "selected" : ""} onClick={() => handleClick("someTime")}>Some Time</Link>
                            <Link to="/19-charlie" className={selectedId === "19charlie" ? "selected" : ""} onClick={() => handleClick("19charlie")}>19 Charlie</Link>
                            <Link to="/bataclan-attack" className={selectedId === "bataclanAttack" ? "selected" : ""} onClick={() => handleClick("bataclanAttack")}>Bataclan Attack</Link>
                        </div>
                        <div className='professional'>
                            <Link to="/commercials" className={selectedId === "commercials" ? "selected" : ""} onClick={() => handleClick("commercials")}>Commercials</Link>
                            <Link to="/prints" onClick={() => handleClick("prints")} className={selectedId === "prints" ? "selected" : ""} >Prints</Link>
                            <Link to="/about" onClick={() => handleClick("about")} className={selectedId === "about" ? "selected" : ""} >About</Link>
                        </div>
                    </div>
                    
                    {/* <div className='commercial-title'>
                        {isCommercialPage && id && <p className="selected">{title[id]}</p>}
                    </div> */}

                    <div className={ menuId === "open" ? "icons open" : "icons"}>
                        <img id="instagramButton" src={Instagram} alt=""/>
                        <img id="emailButton" src={Email} alt=""/>
                    </div>
                </div>
            </nav>
        </div>
        );
};

export default App;